<div class="container">
  <div class="divider"></div>
  <div class="frame-165">
      <div class="frame-64">
        <img class="clipboard-text" src="../../assets/clipboard-text.png" />
      </div>
    <div class="introduction">Task dates</div>
  </div>
  <div class="frame-157">

    <div class="date-fields-wrapper">
      <div class="date-field-container">
        <div class="date-field-label"><b>Start date</b></div>
        <input class="date-field" type="date" [(ngModel)]="startDate" (ngModelChange)="onStartDateChange($event)" />
      </div>
      <div class="date-field-container">
        <div class="date-field-label"><b>End date</b></div>
        <input class="date-field" type="date" [(ngModel)]="endDate" (ngModelChange)="onEndDateChange($event)" />
      </div>
    </div>
  </div>
</div>
